import { Navigate } from "react-router-dom";
import { Tabs } from "@mantine/core";
import { useGate } from "statsig-react";
import { LabelerMetricsTab } from "@/components/admin/LabelerMetricsTab";

export const AdminMetricsPage = () => {
  const { value: isAdmin, isLoading } = useGate("out_of_stock_admin");

  if (isLoading) return null;
  if (!isAdmin) return <Navigate to="/" replace />;

  return (
    <div className="flex flex-col h-full p-6">
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">
        Labeler Metrics
      </h1>
      {/* keepMounted: both panels mount on load, so both task types fetch
          up front and switching tabs is instant. */}
      <Tabs
        defaultValue="oos-confirmation"
        keepMounted
        className="flex flex-col flex-1 min-h-0"
      >
        <Tabs.List mb="md">
          <Tabs.Tab value="oos-confirmation">OOS Confirmation</Tabs.Tab>
          <Tabs.Tab value="coverage-beta">Coverage Beta</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="oos-confirmation" className="flex-1 min-h-0">
          <LabelerMetricsTab taskType="OUT_OF_STOCK_CONFIRMATION" />
        </Tabs.Panel>
        <Tabs.Panel value="coverage-beta" className="flex-1 min-h-0">
          <LabelerMetricsTab taskType="COVERAGE_BETA" />
        </Tabs.Panel>
      </Tabs>
    </div>
  );
};
